exports = module.exports = require("/Volumes/Work/ITCase/baikal430/node_modules/css-loader/cssToString.js")();
exports.push([module.id, ".Video{-o-object-fit:cover;object-fit:cover}", ""]);


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader/lib!./~/stylus-loader!./src/components/Video/Video.styl
// module id = 223
// module chunks = 0